import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getLimitedLocations } from "@/js/http/auth";
import { listContinents } from "@/js/lists.ts";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import addressComponent from "@/components/address/Address.vue";
import StockReservation from "@/components/stock/StockReservation.vue";
export default {
  name: "Warehouse",
  components: {
    confirm: confirmationComponent,
    "address-warehouse": addressComponent,
    StockReservation: StockReservation,
    ErrorModal: ErrorModal
  },
  props: ["baseModel", "stockType", "readOnlyMark", "mode", "listCountries", "listStates", "isEdit", "isInboundForced"],
  data: function data() {
    return {
      readOnly: true,
      form: {
        valid: false
      },
      formDestination: {
        countryId: null,
        stateId: null
      },
      isAddingDestination: false,
      hasChangedDestinations: false,
      syncingStocksIntendedCountries: {
        isPending: false,
        cancellationToken: null
      },
      boolRenderReservation: false,
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAdding: function isAdding() {
      var _this$baseModel;
      return !((_this$baseModel = this.baseModel) !== null && _this$baseModel !== void 0 && _this$baseModel.id_warehouse) > 0;
    },
    listCountriesForAddDestination: function listCountriesForAddDestination() {
      var _this2 = this;
      return this.listCountriesFiltered.filter(function (c) {
        var _this2$listStates, _this2$baseModel;
        return ((_this2$listStates = _this2.listStates) === null || _this2$listStates === void 0 ? void 0 : _this2$listStates.some(function (st) {
          return st.id_country === c.id_country;
        })) || !((_this2$baseModel = _this2.baseModel) !== null && _this2$baseModel !== void 0 && (_this2$baseModel = _this2$baseModel.availableDestinations) !== null && _this2$baseModel !== void 0 && _this2$baseModel.some(function (d) {
          return d.countryId === c.id_country;
        }));
      });
    },
    listCountriesFiltered: function listCountriesFiltered() {
      var copyCountries = _toConsumableArray(this.listCountries);
      var limitedLocations = getLimitedLocations(this.loggedUserData);
      if ((limitedLocations === null || limitedLocations === void 0 ? void 0 : limitedLocations.length) > 0) {
        var _this$user;
        var countryIds = limitedLocations.map(function (x) {
          return x.country_id;
        });
        var deliveryCountryId = (_this$user = this.user) === null || _this$user === void 0 || (_this$user = _this$user.delivery_address) === null || _this$user === void 0 || (_this$user = _this$user.country) === null || _this$user === void 0 ? void 0 : _this$user.id_country;
        if (deliveryCountryId > 0 && !countryIds.includes(deliveryCountryId)) {
          countryIds.push(deliveryCountryId);
        }
        copyCountries = copyCountries.filter(function (x) {
          return countryIds.includes(x.id_country);
        });
      }
      return copyCountries;
    },
    getContinentsFullNames: function getContinentsFullNames() {
      var _this3 = this;
      var fullDepartureNames = [];
      this.baseModel.defaultDepartures.forEach(function (departure) {
        var departureName = listContinents.find(function (x) {
          return x.id === departure.continentIso2;
        }).display_name;
        if (departure.countryId) {
          departureName += " - " + _this3.listCountries.find(function (x) {
            return x.id_country === departure.countryId;
          }).printable_name;
        }
        if (departure.stateId) {
          departureName += ", " + _this3.listStates.find(function (x) {
            return x.id_state == departure.stateId;
          }).state_label;
        }
        fullDepartureNames.push(departureName);
      });
      return fullDepartureNames;
    },
    displayedStatesList: function displayedStatesList() {
      var _this4 = this;
      var displayedListStates = [];
      if (this.formDestination.countryId && this.listCountries.some(function (x) {
        return x.id_country == _this4.formDestination.countryId;
      })) {
        for (var state in this.listStates) {
          if (this.listStates[state].id_country === this.formDestination.countryId) {
            displayedListStates.push(this.listStates[state]);
          }
        }
      }
      return displayedListStates;
    },
    isInvalidFormDestination: function isInvalidFormDestination() {
      var nullishPredicate = function nullishPredicate(x) {
        return !x.countryId;
      };
      if (nullishPredicate(this.formDestination)) return true;
      return false;
    }
  },
  created: function created() {
    this.readOnly = this.readOnlyMark;
  },
  methods: {
    save: function save() {
      if (!this.baseModel.id_warehouse) {
        this.saveWarehouse("post");
      } else {
        this.saveWarehouse("put");
      }
    },
    saveWarehouse: function saveWarehouse(verb) {
      var _this5 = this;
      this.baseModel.type = this.stockType;
      this.$EventBus.$emit("loading", true);
      var _this = this;
      request("/v1/warehouse/", verb, _this.baseModel, true, "api").then(function (response) {
        if (response.status == 201 || response.status == 200) {
          _this.$toasted.show("Warehouse saved.", {
            type: "success"
          });
          _this.$EventBus.$emit("loading", false);
          _this.$emit("saved", response.data ? response.data : _this.baseModel.id_warehouse);
        }
      }).catch(function (err) {
        _this5.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
      });
    },
    confirmSyncStocksIntendedCountries: function confirmSyncStocksIntendedCountries() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this6.$refs.confirm.open("Synchronize stock's intended countries ?", "Are you sure to synchronize the intended countries of all existing stocks of this warehouse ?", {
                color: "red",
                width: 600
              });
            case 2:
              ok = _context.sent;
              if (ok) {
                _this6.syncStocksIntendedCountries();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    syncStocksIntendedCountries: function syncStocksIntendedCountries() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this7$syncingStocksI;
        var _this, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this7.syncingStocksIntendedCountries.isPending = true;
              (_this7$syncingStocksI = _this7.syncingStocksIntendedCountries.cancellationToken) === null || _this7$syncingStocksI === void 0 || _this7$syncingStocksI.cancel();
              _this7.syncingStocksIntendedCountries.cancellationToken = axios.CancelToken.source();
              _this = _this7;
              data = null;
              _context3.next = 7;
              return request("/v1/warehouses/".concat(_this7.baseModel.id_warehouse, "/stocks/intended-countries"), "put", data, true, "api", null, _this.syncingStocksIntendedCountries.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.syncingStocksIntendedCountries.isPending = false;
                          _this.syncingStocksIntendedCountries.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to sync intended countries of stocks.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 7:
              _this7.syncingStocksIntendedCountries.isPending = false;
              _this7.syncingStocksIntendedCountries.cancellationToken = null;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    resetErrorMessages: function resetErrorMessages() {
      this.error.mail = "";
      this.error.name = "";
      this.error.quantity = "";
    },
    cancel: function cancel() {
      if (this.mode != "popin") {
        this.readOnly = true;
        this.getStock();
      } else {
        this.$emit("cancel");
      }
    },
    updateStockReservation: function updateStockReservation(form) {
      var _this8 = this;
      this.baseModel.default_stock_reservation_type = form.stockReservationType;
      this.baseModel.default_stock_reservation_user_id = form.stockReservationUserId;
      this.baseModel.default_stock_reservation_consultant_id = form.stockReservationConsultantId;
      this.$nextTick(function () {
        _this8.boolRenderReservation = !_this8.boolRenderReservation;
      });
    },
    addDestination: function addDestination() {
      var _this9 = this;
      var destination = {
        countryId: this.formDestination.countryId,
        stateId: this.formDestination.stateId
      };
      if (!this.baseModel.availableDestinations.some(function (x) {
        var _this9$formDestinatio;
        return x.countryId == _this9.formDestination.countryId && (!x.stateId || x.stateId == ((_this9$formDestinatio = _this9.formDestination.stateId) !== null && _this9$formDestinatio !== void 0 ? _this9$formDestinatio : 0));
      })) {
        this.baseModel.availableDestinations.push(destination);
      }
      this.hasChangedDestinations = true;
      this.$nextTick(function () {
        var _this9$listCountriesF;
        if (((_this9$listCountriesF = _this9.listCountriesForAddDestination) === null || _this9$listCountriesF === void 0 ? void 0 : _this9$listCountriesF.length) > 0) {
          _this9.formDestination.countryId = _this9.listCountriesForAddDestination[0].id_country;
          _this9.formDestination.stateId = null;
        } else {
          _this9.formDestination.countryId = null;
          _this9.formDestination.stateId = null;
        }
      });
    },
    removeDestination: function removeDestination(item) {
      this.baseModel.availableDestinations.splice(this.baseModel.availableDestinations.indexOf(item), 1);
      this.hasChangedDestinations = true;
    },
    changeCountry: function changeCountry() {
      this.formDestination.stateId = null;
      this.hasChangedDestinations = true;
    }
  }
};